export default __webpack_public_path__ + "images/b9d618a66fe2410a9f0c00c178e3c686-rafting.jpg";